import { Component, inject, OnInit } from '@angular/core';
import { ButtonComponent } from 'cve-ui';
import { CookieService } from '../../services/cookie.service';

@Component({
    selector: 'app-cookies',
    templateUrl: './cookies.component.html',
    styleUrl: './cookies.component.scss',
    imports: [ButtonComponent],
})
export class CookiesComponent implements OnInit {
  readonly cookieService = inject(CookieService);

  hidden = false;

  ngOnInit() {
    if (this.cookieService.getCookie('orego-website')) {
      this.hidden = true;
    }
  }

  hideCookies() {
    this.cookieService.setCookie('orego-website', '1', 10);
    this.hidden = true;
  }
}
